import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  const handleLogin = () => {
    // Add login logic
  };

  return (
    <div>

      <section className="hero text-center" style={{
        background: 'linear-gradient(rgba(76, 175, 80, 0.8), rgba(76, 175, 80, 0.8)), url("https://picsum.photos/1200/400?random=1")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#ffffff',
        padding: '100px 0'
      }}>
        <div className="container">
          <h1 className="display-4 mb-4">Welcome to MintDeals</h1>
          <h4>Empowering Collective Financial Growth for Everyone</h4>
          <p className="lead mb-5">MintDeals is a decentralized platform where members, businesses, and partners come together to maximize savings and earn rewards through collective purchasing power. Whether you're here to find deals, grow your business, or connect communities, MintDeals has something for you.</p>
          <button id="ctaOnboardButton" className="btn btn-kmint-orange btn-lg mx-2">
            <Link to="/onboarding" className="nav-link">
              Get Started
            </Link>
          </button>
          <button id="ctaExploreButton" className="btn btn-kmint-blue btn-lg mx-2">
            <Link to="/explore" className="nav-link">
              Explore Clubs
            </Link>
          </button>
        </div>
      </section>

      <section className="features py-5">
        <div className="container">
          <h2 className="text-center mb-5">Why Join MintDeals?</h2>
          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <i className="fas fa-users feature-icon" style={{ fontSize: '3rem', color: '#4CAF50' }}></i>
              <h3>For Members</h3>
              <p>Join clubs and access exclusive deals. Save money and earn rewards as you benefit from collective purchasing power. It's simple, transparent, and secure.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i className="fas fa-briefcase feature-icon" style={{ fontSize: '3rem', color: '#4CAF50' }}></i>
              <h3>For Businesses</h3>
              <p>Expand your reach by creating clubs and offering exclusive deals. Access credit based on club performance and increase sales with minimal overhead.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i className="fas fa-handshake feature-icon" style={{ fontSize: '3rem', color: '#4CAF50' }}></i>
              <h3>For Partners</h3>
              <p>Connect with businesses and communities to help grow MintDeals's network. Earn rewards by referring members and businesses to the platform.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">How It Works</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">1. Connect Your Wallet</h5>
                  <p className="card-text">Securely connect your cryptocurrency wallet using our Web3 login to start your journey with MintDeals.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">2. Choose Your Role</h5>
                  <p className="card-text">Select whether you want to join as a Member, Business, or Partner. Each role comes with unique benefits and opportunities.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">3. Start Earning & Saving</h5>
                  <p className="card-text">Engage in the community by joining clubs, creating deals, or connecting others. Earn rewards and enjoy collective savings effortlessly.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials py-5">
        <div className="container">
          <h2 className="text-center mb-5">What Our Users Say</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="testimonial" style={{
                backgroundColor: '#ffffff',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '20px'
              }}>
                <div className="d-flex align-items-center mb-3">
                  <img src="https://picsum.photos/60/60?random=1" alt="User 1" className="rounded-circle" style={{ width: '60px', height: '60px', marginRight: '15px' }} />
                  <div>
                    <h5 className="mb-0">Emma Visser</h5>
                    <small className="text-muted">Crypto Enthusiast & Marketer</small>
                  </div>
                </div>
                <p>"As a member, I've saved more money than I ever imagined. MintDeals's platform is easy to use and incredibly rewarding."</p>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="testimonial" style={{
                backgroundColor: '#ffffff',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '20px'
              }}>
                <div className="d-flex align-items-center mb-3">
                  <img src="https://picsum.photos/60/60?random=2" alt="User 2" className="rounded-circle" style={{ width: '60px', height: '60px', marginRight: '15px' }} />
                  <div>
                    <h5 className="mb-0">Liam de Vries</h5>
                    <small className="text-muted">Blockchain Developer & Entrepreneur</small>
                  </div>
                </div>
                <p>"MintDeals has transformed the way I do business. The ability to create clubs and offer deals has driven new customers and increased my revenue significantly."</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section" style={{ backgroundColor: '#f8f9fa', padding: '80px 0' }}>
        <div className="container text-center">
          <h2 className="mb-4">Ready to Join MintDeals?</h2>
          <p className="mb-4">Connect your wallet now and choose your role to start benefiting from our decentralized network!</p>
          <button className="btn btn-kmint-blue btn-lg">
            <Link to="/onboarding/" className="nav-link">
              Get Started
            </Link>
          </button>
        </div>
      </section>

    </div>
  );
}

export default Home;
